import { InteractionType, LogLevel } from "@azure/msal-browser";

export type AzureAuthConfiguration = {
    /**
     * If your application audience is a single tenant, you must provide an authority with your tenant id like below:
     */
    authorityUrl: string;

    /**
     * Client ID of the application. You can obtain this value from the app registration in Azure AD.
     */
    clientId: string;

    /**
     * By default, MSAL is configured to set the redirect URI to the current page that it is running on. If you would
     * like to receive the authorization code on a different page, set this in the configuration
     */
    redirectUrl?: string;

    /**
     * Library will navigate to this URI after logout. Can be also set directly on logout action.
     */
    postLogoutRedirectUrl?: string;

    /**
     * If your application is using a separate OIDC-compliant authority or an IdentityServer, you will need to provide
     * it in the knownAuthorities
     */
    knownAuthorities?: string[];

    /**
     * Set log level if needed (default is AzureAdLogLevel.Error)
     */
    logLevel?: LogLevel;
};

type LoginInteractionFunctionName = "loginPopup" | "loginRedirect";

export const getLoginFunctionName = (interactionType: InteractionType): LoginInteractionFunctionName => {
    switch (interactionType) {
        case InteractionType.Popup:
            return "loginPopup";
        case InteractionType.Redirect:
            return "loginRedirect";
        default:
            throw new Error(`Unsupported interaction type: ${interactionType}`);
    }
};

type LogoutInteractionFunctionName = "logoutPopup" | "logoutRedirect";

export const getLogoutFunctionName = (interactionType: InteractionType): LogoutInteractionFunctionName => {
    switch (interactionType) {
        case InteractionType.Popup:
            return "logoutPopup";
        case InteractionType.Redirect:
            return "logoutRedirect";
        default:
            throw new Error(`Unsupported interaction type: ${interactionType}`);
    }
};

type TokenAcquisitionFunctionName = "acquireTokenPopup" | "acquireTokenRedirect";

export const getAcquireTokenFunctionName = (interactionType: InteractionType): TokenAcquisitionFunctionName => {
    switch (interactionType) {
        case InteractionType.Popup:
            return "acquireTokenPopup";
        case InteractionType.Redirect:
            return "acquireTokenRedirect";
        default:
            throw new Error(`Unsupported interaction type: ${interactionType}`);
    }
};
